export type AutoContext = {
  timestamp: boolean;
  location: boolean;
  language: boolean;
  timezone: boolean;
  screen: boolean;
  locationValue: string;
};

export const DEFAULT_AUTO_CONTEXT: AutoContext = {
  timestamp: true,
  location: false,
  language: true,
  timezone: true,
  screen: true,
  locationValue: "",
};

export function estimateScreenCharCapacity(): number {
  if (typeof window === "undefined") return 0;
  const w = window.innerWidth;
  const h = window.innerHeight;
  const charsPerLine = Math.max(20, Math.floor(w / 8));
  const lines = Math.max(5, Math.floor(h / 22));
  return charsPerLine * lines;
}

export function buildContextBlock(ctx: AutoContext): string {
  const lines: string[] = [];

  if (ctx.timestamp) lines.push(`Current time: ${new Date().toLocaleString()}`);
  if (ctx.language) lines.push(`User language: ${navigator.language}`);
  if (ctx.timezone) lines.push(`Timezone: ${Intl.DateTimeFormat().resolvedOptions().timeZone}`);
  if (ctx.location && ctx.locationValue) lines.push(`Location: ${ctx.locationValue}`);
  if (ctx.screen) {
    const cap = estimateScreenCharCapacity();
    if (cap > 0) {
      lines.push(
        `Visible screen capacity: ~${cap} characters (consider keeping responses within this length unless detail is requested)`,
      );
    }
  }

  if (lines.length === 0) return "";
  return `[User Context]\n${lines.join("\n")}`;
}

export async function requestLocation(): Promise<string> {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation not supported"));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve(`${pos.coords.latitude.toFixed(4)}, ${pos.coords.longitude.toFixed(4)}`),
      (err) => reject(err),
      { timeout: 10000 },
    );
  });
}
